module.exports = __webpack_public_path__ + "static/image1-009fb71261df28a35c130771b60967ea.jpg";